// // new new
// import React from "react";
// import img from "../images/web.svg";
// import img1 from "../images/undraw_web_development_0l6v.svg";
// import img2 from "../images/app.svg";
// import img3 from "../images/hosting.svg";
// import img4 from "../images/consultation.svg";
// import img5 from "../images/undraw_content_team_re_6rlg.svg";
// import img6 from "../images/undraw_security_re_a2rk.svg";
// import img7 from "../images/seo.svg";
// import img8 from "../images/undraw_mobile_marketing_re_p77p.svg";
// import img9 from "../images/undraw_calculator_re_alsc.svg";
// import img10 from "../images/undraw_growth_curve_re_t5s7.svg";
// import img11 from "../images/undraw_crypto_portfolio_2jy5.svg";
// import { Link } from "react-router-dom";

// const Services = () => {
//   return (
//     <div id="services" className="bg-gray-100 py-2 ">
//       <section data-aos="zoom-in-down">
//         <div className="my-4 py-4">
//           <h2 className="my-2 text-center text-3xl text-blue-900 uppercase font-bold">
//             Services
//           </h2>

//           <div className="flex justify-center">
//             <div className="w-24 border-b-4 border-blue-900"></div>
//           </div>
//           <h2 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-blue-900">
//             We are deeply committed to the growth and success of our clients.
//           </h2>
//         </div>

//         <div className="px-12" data-aos="fade-down" data-aos-delay="600">
//           <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
//             {/* customised web app */}
//             <Link to="/contact">
//               <div id="custom-software-development" className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-gray-500 hover:text-white rounded-lg shadow-2xl p-3 group h-full">
//                 <div className="m-2 text-justify text-sm">
//                   <img
//                     alt="card img"
//                     className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out"
//                     src={img}
//                   />
//                   <h2 className="font-semibold my-4 text-2xl text-center">
//                     Custom Software Development
//                   </h2>
//                   <p className="text-md font-medium">
//                     At Skyland Web, we assist you in crafting diverse and
//                     sophisticated software solutions tailored to your business
//                     requirements. By attentively listening to your ideas, we
//                     meticulously implement and design custom software solutions
//                     from the ground up, uniquely suited to your business. With
//                     Skyland Web, you can trust that you'll receive top-notch
//                     software and impeccable service with every project.
//                   </p>
//                 </div>
//               </div>
//             </Link>
//             {/* Web Development */}
//             <Link to="/contact">
//               <div id="web-application-development" className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-gray-500 hover:text-white rounded-lg shadow-2xl p-3 group h-full">
//                 <div className="m-2 text-justify text-sm">
//                   <img
//                     alt="card img"
//                     className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out"
//                     src={img1}
//                   />
//                   <h2 className="font-semibold my-4 text-2xl text-center">
//                     Web Application Development
//                   </h2>
//                   <p className="text-md font-medium">
//                     At Skyland Web, we go beyond conventional solutions to
//                     create innovative web applications. Our skilled and
//                     dedicated web development team understands your needs and
//                     leverages modern web frameworks to develop high-value
//                     business applications. Whether you need a simple website or
//                     a complex web platform, we are here to turn your vision into
//                     reality.
//                   </p>
//                 </div>
//               </div>
//             </Link>

//             {/* Mobile App Development */}
//             <Link to="/contact">
//               <div id="mobile-app-development" className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-gray-500 hover:text-white rounded-lg shadow-2xl p-3 group h-full">
//                 <div className="m-2 text-justify text-sm">
//                   <img
//                     alt="card img"
//                     className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out"
//                     src={img2}
//                   />
//                   <h2 className="font-semibold my-4 text-2xl text-center">
//                     Mobile App Development
//                   </h2>
//                   <p className="text-md font-medium">
//                     We develop high-quality, custom cross-platform mobile
//                     applications that are robust and optimized for performance,
//                     scalability, and accessibility.
//                   </p>
//                 </div>
//               </div>
//             </Link>

//             {/* Domain and Hosting Services */}
//             <Link to="/contact">
//               <div id="domain-hosting-services" className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-gray-500 hover:text-white rounded-lg shadow-2xl p-3 group h-full">
//                 <div className="m-2 text-justify text-sm">
//                   <img
//                     alt="card img"
//                     className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out"
//                     src={img3}
//                   />
//                   <h2 className="font-semibold my-4 text-2xl text-center">
//                     Domain and Hosting Services
//                   </h2>
//                   <p className="text-md font-medium">
//                     We provide domain registration and web hosting services to
//                     individuals and organizations to enable them gain visibility
//                     in the digital space.
//                   </p>
//                 </div>
//               </div>
//             </Link>

//             {/* IT Consultations */}
//             <Link to="/contact">
//               <div id="IT-consultations" className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-gray-500 hover:text-white rounded-lg shadow-2xl p-3 group h-full">
//                 <div className="m-2 text-justify text-sm">
//                   <img
//                     alt="card img"
//                     className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out"
//                     src={img4}
//                   />
//                   <h2 className="font-semibold my-4 text-2xl text-center">
//                     General IT Consultations
//                   </h2>
//                   <p className="text-md font-medium">
//                     Our IT consultations service provides expert guidance and
//                     support for businesses and individuals looking to optimize
//                     their technology solutions.
//                   </p>
//                 </div>
//               </div>
//             </Link>

//             {/* Content Creation Services */}
//             <Link to="/contact">
//               <div id="content-creation-services" className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-gray-500 hover:text-white rounded-lg shadow-2xl p-3 group h-full">
//                 <div className="m-2 text-justify text-sm">
//                   <img
//                     alt="card img"
//                     className="rounded-t group                      hover:scale-[1.15] transition duration-1000 ease-in-out"
//                     src={img5}
//                   />
//                   <h2 className="font-semibold my-4 text-2xl text-center">
//                     Content Creation Services
//                   </h2>
//                   <p className="text-md font-medium">
//                     Custom logos, image generation, videos, banner designs,
//                     leaflets/flyers, business cards, and marketing materials to
//                     enhance your brand's visibility and appeal.
//                   </p>
//                 </div>
//               </div>
//             </Link>

//             {/* Cybersecurity Services */}
//             <Link to="/contact">
//               <div id="cybersecurity-services" className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-gray-500 hover:text-white rounded-lg shadow-2xl p-3 group h-full">
//                 <div className="m-2 text-justify text-sm">
//                   <img
//                     alt="card img"
//                     className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out"
//                     src={img6}
//                   />
//                   <h2 className="font-semibold my-4 text-2xl text-center">
//                     Cybersecurity Services
//                   </h2>
//                   <p className="text-md font-medium">
//                     Penetration testing to identify vulnerabilities and secure
//                     your systems from potential threats.
//                   </p>
//                 </div>
//               </div>
//             </Link>

//             {/* SEO Services */}
//             <Link to="/contact">
//               <div id="SEO-services" className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-gray-500 hover:text-white rounded-lg shadow-2xl p-3 group h-full">
//                 <div className="m-2 text-justify text-sm">
//                   <img
//                     alt="card img"
//                     className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out"
//                     src={img7}
//                   />
//                   <h2 className="font-semibold my-4 text-2xl text-center">
//                     SEO Services
//                   </h2>
//                   <p className="text-md font-medium">
//                     Offline and online SEO strategies to boost your search
//                     engine rankings and drive organic traffic to your site.
//                   </p>
//                 </div>
//               </div>
//             </Link>

//             {/* Digital Marketing Services */}
//             <Link to="/contact">
//               <div id="digital-marketing-services" className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-gray-500 hover:text-white rounded-lg shadow-2xl p-3 group h-full">
//                 <div className="m-2 text-justify text-sm">
//                   <img
//                     alt="card img"
//                     className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out"
//                     src={img8}
//                   />
//                   <h2 className="font-semibold my-4 text-2xl text-center">
//                     Digital Marketing Services
//                   </h2>
//                   <p className="text-md font-medium">
//                     Google, Facebook, Instagram, TikTok, Twitter, YouTube, and
//                     influencer marketing to expand your online presence and
//                     engage with your target audience.
//                   </p>
//                 </div>
//               </div>
//             </Link>

//             {/* Accounting Services */}
//             <Link to="/contact">
//               <div id="accounting-services" className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-gray-500 hover:text-white rounded-lg shadow-2xl p-3 group h-full">
//                 <div className="m-2 text-justify text-sm">
//                   <img
//                     alt="card img"
//                     className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out"
//                     src={img9}
//                   />
//                   <h2 className="font-semibold my-4 text-2xl text-center">
//                     Accounting Services
//                   </h2>
//                   <p className="text-md font-medium">
//                     Bookkeeping, virtual CFO services, and management of
//                     corporate finance to streamline your financial operations.
//                   </p>
//                 </div>
//               </div>
//             </Link>

//             {/* Data Entry Services */}
//             <Link to="/contact">
//               <div id="data-entry-services" className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-gray-500 hover:text-white rounded-lg shadow-2xl p-3 group h-full">
//                 <div className="m-2 text-justify text-sm">
//                   <img
//                     alt="card img"
//                     className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out"
//                     src={img10}
//                   />
//                   <h2 className="font-semibold my-4 text-2xl text-center">
//                     Data Entry Services
//                   </h2>
//                   <p className="text-md font-medium">
//                     Professional data entry solutions to ensure accuracy and
//                     efficiency in handling your data.
//                   </p>{" "}
//                 </div>
//               </div>
//             </Link>

//             {/* Crypto Tracing Services */}
//             <Link to="/contact">
//               <div id="crypto-tracing-services" className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-gray-500 hover:text-white rounded-lg shadow-2xl p-3 group">
//                 <div className="m-2 text-justify text-sm">
//                   <img
//                     alt="card img"
//                     className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out"
//                     src={img11}
//                   />
//                   <h2 className="font-semibold my-4 text-2xl text-center">
//                     Crypto Tracing Services
//                   </h2>
//                   <p className="text-md font-medium">
//                     Skyland Web provides thorough crypto tracing services,
//                     enabling you to monitor and analyze blockchain transactions
//                     with ease. Our expert team ensures transparency and security
//                     in your cryptocurrency operations, offering insights to
//                     support informed decision-making.
//                   </p>
//                 </div>
//               </div>
//             </Link>
//             {/* Outreach Services */}
//             {/* <Link to="/contact">
//               <div id="outreach-services" className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-gray-500 hover:text-white rounded-lg shadow-2xl p-3 group ">
//                 <div className="m-2 text-justify text-sm">
//                   <img
//                     alt="card img"
//                     className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out"
//                     src={img10} // Replace with the appropriate image for Outreach Services
//                   />
//                   <h2 className="font-semibold my-4 text-2xl text-center">
//                     Outreach Services
//                   </h2>
//                   <p className="text-md font-medium">
//                     Skyland Web's Outreach Services are dedicated to helping you extend your
//                     reach and impact within your community. We offer strategic planning,
//                     community engagement, and outreach program development to connect you with
//                     your target audience effectively. Our services include cold calling, cold emailing,
//                     and personalized outreach strategies to ensure your message resonates. Let us help
//                     you build strong, lasting relationships and foster meaningful connections through our expert outreach
//                     services.
//                   </p>
//                 </div>
//               </div>
//             </Link> */}

//           </div>
//         </div>
//       </section>

//       <section>
//         <div className="m-auto max-w-6xl p-2 md:p-12 h-5/6">
//           <div
//             className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left"
//             data-aos="zoom-out"
//           >
//             <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
//               <div className="text-blue-900 mb-4">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="72"
//                   height="72"
//                   viewBox="0 0 24 24"
//                   className="fill-current"
//                 >
//                   <path d="M2 12h2a7.986 7.986 0 0 1 2.337-5.663 7.91 7.91 0 0 1 2.542-1.71 8.12 8.12 0 0 1 6.13-.041A2.488 2.488 0 0 0 17.5 7C18.886 7 20 5.886 20 4.5S18.886 2 17.5 2c-.689 0-1.312.276-1.763.725-2.431-.973-5.223-.958-7.635.059a9.928 9.928 0 0 0-3.18 2.139 9.92 9.92 0 0 0-2.14 3.179A10.005 10.005 0 0 0 2 12zm17.373 3.122c-.401.952-.977 1.808-1.71 2.541s-1.589 1.309-2.542 1.71a8.12 8.12 0 0 1-6.13.041A2.488 2.488 0 0 0 6.5 17C5.114 17 4 18.114 4 19.5S5.114 22 6.5 22c.689 0 1.312-.276 1.763-.725A9.965 9.965 0 0 0 12 22a9.983 9.983 0 0 0 9.217-6.102A9.992 9.992 0 0 0 22 12h-2a7.993 7.993 0 0 1-.627 3.122z"></path>
//                   <path d="M12 7.462c-2.502 0-4.538 2.036-4.538 4.538S9.498 16.538 12 16.538s4.538-2.036 4.538-4.538S14.502 7.462 12 7.462zm0 7.076c-1.399 0-2.538-1.139-2.538-2.538S10.601 9.462 12 9.462s2.538 1.139 2.538 2.538-1.139 2.538-2.538 2.538z"></path>
//                 </svg>
//               </div>
//               <h3 className="text-3xl text-blue-900 font-bold">
//                 We <span className="font-black">Build</span>
//               </h3>
//               <div>
//                 <p className="my-3 text-xl text-gray-600 font-semibold">
//                   With over 5 years experience in software analysis and design
//                   and a deep understanding of the latest IT trends and
//                   solutions, we provide customized recommendations and
//                   strategies to help you improve your operations, reduce costs,
//                   and increase efficiency.
//                 </p>
//               </div>
//             </div>
//             <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
//               <div className="text-blue-900 mb-4">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="72"
//                   height="72"
//                   viewBox="0 0 24 24"
//                   className="fill-current"
//                 >
//                   <path d="m7.375 16.781 1.25-1.562L4.601 12l4.024-3.219-1.25-1.562-5 4a1 1 0 0 0 0 1.562l5 4zm9.25-9.562-1.25 1.562L19.399 12l-4.024 3.219 1.25 1.562 5-4a1 1 0 0 0 0-1.562l-5-4zm-1.649-4.003-4 18-1.953-.434 4-18z"></path>
//                 </svg>
//               </div>
//               <h3 className="text-3xl text-blue-900 font-bold">
//                 We <span className="font-black">Collaborate</span>
//               </h3>
//               <div>
//                 <p className="my-3 text-xl text-gray-600 font-semibold">
//                   We can collaborate with your existing tech team to scale
//                   existing software applications or design customized software
//                   applications that suits your everyday need and simplifies
//                   various processes.
//                 </p>
//               </div>
//             </div>
//             {/*  Outreach services */}

//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Services;



// import React from "react";
// import { Link } from "react-router-dom";
// import { FaMobileAlt, FaGlobe, FaServer, FaShieldAlt, FaChartLine, FaPenFancy, FaRobot, FaBitcoin, FaCalculator, FaDatabase } from "react-icons/fa";
// import { MdWeb, MdDesignServices, MdOutlineSupportAgent } from "react-icons/md";

// const Services = () => {
//   const services = [
//     {
//       id: "custom-software-development",
//       title: "Custom Software Development",
//       icon: <MdWeb className="text-4xl text-blue-600" />,
//       description: "Tailored software solutions designed from the ground up to meet your unique business requirements with impeccable service.",
//       color: "bg-blue-50 hover:bg-blue-100"
//     },
//     {
//       id: "web-application-development",
//       title: "Web Application Development",
//       icon: <FaGlobe className="text-4xl text-green-600" />,
//       description: "Innovative web applications built with modern frameworks to create high-value business solutions.",
//       color: "bg-green-50 hover:bg-green-100"
//     },
//     {
//       id: "mobile-app-development",
//       title: "Mobile App Development",
//       icon: <FaMobileAlt className="text-4xl text-purple-600" />,
//       description: "High-quality cross-platform mobile applications optimized for performance and scalability.",
//       color: "bg-purple-50 hover:bg-purple-100"
//     },
//     {
//       id: "domain-hosting-services",
//       title: "Domain & Hosting",
//       icon: <FaServer className="text-4xl text-red-600" />,
//       description: "Complete domain registration and web hosting solutions for digital visibility.",
//       color: "bg-red-50 hover:bg-red-100"
//     },
//     {
//       id: "IT-consultations",
//       title: "IT Consultations",
//       icon: <MdOutlineSupportAgent className="text-4xl text-yellow-600" />,
//       description: "Expert guidance to optimize your technology solutions and business operations.",
//       color: "bg-yellow-50 hover:bg-yellow-100"
//     },
//     {
//       id: "content-creation-services",
//       title: "Content Creation",
//       icon: <FaPenFancy className="text-4xl text-pink-600" />,
//       description: "Custom logos, videos, marketing materials to enhance your brand's appeal.",
//       color: "bg-pink-50 hover:bg-pink-100"
//     },
//     {
//       id: "cybersecurity-services",
//       title: "Cybersecurity",
//       icon: <FaShieldAlt className="text-4xl text-indigo-600" />,
//       description: "Penetration testing and security solutions to protect your systems.",
//       color: "bg-indigo-50 hover:bg-indigo-100"
//     },
//     {
//       id: "SEO-services",
//       title: "SEO Services",
//       icon: <FaChartLine className="text-4xl text-teal-600" />,
//       description: "Strategies to boost search rankings and drive organic traffic.",
//       color: "bg-teal-50 hover:bg-teal-100"
//     },
//     {
//       id: "digital-marketing-services",
//       title: "Digital Marketing",
//       icon: <MdDesignServices className="text-4xl text-orange-600" />,
//       description: "Comprehensive marketing across all major platforms to expand your reach.",
//       color: "bg-orange-50 hover:bg-orange-100"
//     },
//     {
//       id: "accounting-services",
//       title: "Accounting Services",
//       icon: <FaCalculator className="text-4xl text-amber-600" />,
//       description: "Bookkeeping and financial management to streamline operations.",
//       color: "bg-amber-50 hover:bg-amber-100"
//     },
//     {
//       id: "data-entry-services",
//       title: "Data Entry",
//       icon: <FaDatabase className="text-4xl text-cyan-600" />,
//       description: "Accurate and efficient data handling solutions.",
//       color: "bg-cyan-50 hover:bg-cyan-100"
//     },
//     {
//       id: "crypto-tracing-services",
//       title: "Crypto Tracing",
//       icon: <FaBitcoin className="text-4xl text-gray-600" />,
//       description: "Blockchain transaction monitoring for transparency and security.",
//       color: "bg-gray-50 hover:bg-gray-100"
//     }
//   ];

//   return (
//     <div id="services" className="py-16 bg-gradient-to-b from-gray-50 to-white">
//       {/* Header Section */}
//       <div className="text-center mb-16 px-4">
//         <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
//           Our <span className="text-blue-600">Services</span>
//         </h2>
//         <div className="w-20 h-1 bg-blue-600 mx-auto mb-6"></div>
//         <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto">
//           We deliver cutting-edge solutions tailored to your business needs
//         </p>
//       </div>

//       {/* Services Grid */}
//       <div className="container mx-auto px-4">
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//           {services.map((service) => (
//             <Link 
//               to="/contact" 
//               key={service.id}
//               className="transform transition-all hover:scale-105 duration-300"
//             >
//               <div className={`${service.color} rounded-xl shadow-lg p-6 h-full flex flex-col`}>
//                 <div className="mb-4 flex justify-center">
//                   <div className="p-3 rounded-full bg-white shadow-md">
//                     {service.icon}
//                   </div>
//                 </div>
//                 <h3 className="text-xl font-bold text-gray-800 mb-3 text-center">
//                   {service.title}
//                 </h3>
//                 <p className="text-gray-600 flex-grow">
//                   {service.description}
//                 </p>
//                 <div className="mt-4 text-center">
//                   <span className="inline-block px-4 py-2 text-sm font-medium text-blue-600 bg-white rounded-full shadow">
//                     Learn More →
//                   </span>
//                 </div>
//               </div>
//             </Link>
//           ))}
//         </div>
//       </div>

    
//    <section className="bg-gradient-to-r from-blue-50 to-indigo-50 py-16">
//   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//     <div className="flex flex-col lg:flex-row gap-12 lg:gap-8 xl:gap-16">
//       {/* We Build Section */}
//       <div className="lg:w-1/2">
//         <div className="bg-white rounded-2xl shadow-xl p-8 h-full transform transition-all hover:scale-[1.02] duration-300 border border-gray-100">
//           <div className="flex flex-col h-full">
//             <div className="flex items-center mb-6">
//               <div className="bg-blue-100 p-4 rounded-full mr-6">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="48"
//                   height="48"
//                   viewBox="0 0 24 24"
//                   className="fill-current text-blue-600"
//                 >
//                   <path d="M2 12h2a7.986 7.986 0 0 1 2.337-5.663 7.91 7.91 0 0 1 2.542-1.71 8.12 8.12 0 0 1 6.13-.041A2.488 2.488 0 0 0 17.5 7C18.886 7 20 5.886 20 4.5S18.886 2 17.5 2c-.689 0-1.312.276-1.763.725-2.431-.973-5.223-.958-7.635.059a9.928 9.928 0 0 0-3.18 2.139 9.92 9.92 0 0 0-2.14 3.179A10.005 10.005 0 0 0 2 12zm17.373 3.122c-.401.952-.977 1.808-1.71 2.541s-1.589 1.309-2.542 1.71a8.12 8.12 0 0 1-6.13.041A2.488 2.488 0 0 0 6.5 17C5.114 17 4 18.114 4 19.5S5.114 22 6.5 22c.689 0 1.312-.276 1.763-.725A9.965 9.965 0 0 0 12 22a9.983 9.983 0 0 0 9.217-6.102A9.992 9.992 0 0 0 22 12h-2a7.993 7.993 0 0 1-.627 3.122z"></path>
//                   <path d="M12 7.462c-2.502 0-4.538 2.036-4.538 4.538S9.498 16.538 12 16.538s4.538-2.036 4.538-4.538S14.502 7.462 12 7.462zm0 7.076c-1.399 0-2.538-1.139-2.538-2.538S10.601 9.462 12 9.462s2.538 1.139 2.538 2.538-1.139 2.538-2.538 2.538z"></path>
//                 </svg>
//               </div>
//               <h3 className="text-3xl font-bold text-gray-900">
//                 We <span className="text-blue-600">Build</span>
//               </h3>
//             </div>
//             <p className="text-lg text-gray-600 mb-6 flex-grow">
//               With over 5 years experience in software analysis and design and a deep understanding of the latest IT trends and solutions, we provide customized recommendations and strategies to help you improve your operations, reduce costs, and increase efficiency.
//             </p>
//             <div className="mt-auto">
//               <div className="grid grid-cols-2 gap-4">
//                 <div className="bg-blue-50 p-4 rounded-lg text-center">
//                   <span className="block text-2xl font-bold text-blue-600">5+</span>
//                   <span className="text-sm text-gray-600">Years Experience</span>
//                 </div>
//                 <div className="bg-blue-50 p-4 rounded-lg text-center">
//                   <span className="block text-2xl font-bold text-blue-600">100+</span>
//                   <span className="text-sm text-gray-600">Projects</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* We Collaborate Section */}
//       <div className="lg:w-1/2">
//         <div className="bg-white rounded-2xl shadow-xl p-8 h-full transform transition-all hover:scale-[1.02] duration-300 border border-gray-100">
//           <div className="flex flex-col h-full">
//             <div className="flex items-center mb-6">
//               <div className="bg-green-100 p-4 rounded-full mr-6">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="48"
//                   height="48"
//                   viewBox="0 0 24 24"
//                   className="fill-current text-green-600"
//                 >
//                   <path d="m7.375 16.781 1.25-1.562L4.601 12l4.024-3.219-1.25-1.562-5 4a1 1 0 0 0 0 1.562l5 4zm9.25-9.562-1.25 1.562L19.399 12l-4.024 3.219 1.25 1.562 5-4a1 1 0 0 0 0-1.562l-5-4zm-1.649-4.003-4 18-1.953-.434 4-18z"></path>
//                 </svg>
//               </div>
//               <h3 className="text-3xl font-bold text-gray-900">
//                 We <span className="text-green-600">Collaborate</span>
//               </h3>
//             </div>
//             <p className="text-lg text-gray-600 mb-6 flex-grow">
//               We can collaborate with your existing tech team to scale existing software applications or design customized software applications that suits your everyday need and simplifies various processes.
//             </p>
//             <div className="mt-auto">
//               <ul className="space-y-3">
//                 {[
//                   "Seamless team integration",
//                   "Agile development process",
//                   "Continuous communication",
//                   "Regular progress updates"
//                 ].map((item, index) => (
//                   <li key={index} className="flex items-center">
//                     <svg className="w-5 h-5 text-green-500 mr-3" fill="currentColor" viewBox="0 0 20 20">
//                       <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
//                     </svg>
//                     <span className="text-gray-700">{item}</span>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// </section>
//     </div>
//   );
// };

// export default Services;

// import React from "react";
// import { Link } from "react-router-dom";
// import { 
//   FaMobileAlt, FaGlobe, FaServer, FaShieldAlt, FaChartLine, 
//   FaPenFancy, FaBitcoin, FaCalculator, FaDatabase 
// } from "react-icons/fa";
// import { 
//   MdWeb, MdDesignServices, MdOutlineSupportAgent 
// } from "react-icons/md";
// import { Helmet } from "react-helmet";

// const Services = () => {
//   const services = [
//     {
//       id: "custom-software-development",
//       title: "Custom Software Development",
//       icon: <MdWeb className="text-4xl text-blue-600" />,
//       description: "Tailored software solutions designed from the ground up to meet your unique business requirements with impeccable service.",
//       color: "bg-blue-50 hover:bg-blue-100"
//     },
//     {
//       id: "web-application-development",
//       title: "Web Application Development",
//       icon: <FaGlobe className="text-4xl text-green-600" />,
//       description: "Innovative web applications built with modern frameworks to create high-value business solutions.",
//       color: "bg-green-50 hover:bg-green-100"
//     },
//     {
//       id: "mobile-app-development",
//       title: "Mobile App Development",
//       icon: <FaMobileAlt className="text-4xl text-purple-600" />,
//       description: "High-quality cross-platform mobile applications optimized for performance and scalability.",
//       color: "bg-purple-50 hover:bg-purple-100"
//     },
//     {
//       id: "domain-hosting-services",
//       title: "Domain & Hosting",
//       icon: <FaServer className="text-4xl text-red-600" />,
//       description: "Complete domain registration and web hosting solutions for digital visibility.",
//       color: "bg-red-50 hover:bg-red-100"
//     },
//     {
//       id: "IT-consultations",
//       title: "IT Consultations",
//       icon: <MdOutlineSupportAgent className="text-4xl text-yellow-600" />,
//       description: "Expert guidance to optimize your technology solutions and business operations.",
//       color: "bg-yellow-50 hover:bg-yellow-100"
//     },
//     {
//       id: "content-creation-services",
//       title: "Content Creation",
//       icon: <FaPenFancy className="text-4xl text-pink-600" />,
//       description: "Custom logos, videos, marketing materials to enhance your brand's appeal.",
//       color: "bg-pink-50 hover:bg-pink-100"
//     },
//     {
//       id: "cybersecurity-services",
//       title: "Cybersecurity",
//       icon: <FaShieldAlt className="text-4xl text-indigo-600" />,
//       description: "Penetration testing and security solutions to protect your systems.",
//       color: "bg-indigo-50 hover:bg-indigo-100"
//     },
//     {
//       id: "SEO-services",
//       title: "SEO Services",
//       icon: <FaChartLine className="text-4xl text-teal-600" />,
//       description: "Strategies to boost search rankings and drive organic traffic.",
//       color: "bg-teal-50 hover:bg-teal-100"
//     },
//     {
//       id: "digital-marketing-services",
//       title: "Digital Marketing",
//       icon: <MdDesignServices className="text-4xl text-orange-600" />,
//       description: "Comprehensive marketing across all major platforms to expand your reach.",
//       color: "bg-orange-50 hover:bg-orange-100"
//     },
//     {
//       id: "accounting-services",
//       title: "Accounting Services",
//       icon: <FaCalculator className="text-4xl text-amber-600" />,
//       description: "Bookkeeping and financial management to streamline operations.",
//       color: "bg-amber-50 hover:bg-amber-100"
//     },
//     {
//       id: "data-entry-services",
//       title: "Data Entry",
//       icon: <FaDatabase className="text-4xl text-cyan-600" />,
//       description: "Accurate and efficient data handling solutions.",
//       color: "bg-cyan-50 hover:bg-cyan-100"
//     },
//     {
//       id: "crypto-tracing-services",
//       title: "Crypto Tracing",
//       icon: <FaBitcoin className="text-4xl text-gray-600" />,
//       description: "Blockchain transaction monitoring for transparency and security.",
//       color: "bg-gray-50 hover:bg-gray-100"
//     }
//   ];

//   return (
//     <>
//       {/* SEO Meta Tags */}
//       <Helmet>
//         <title>Our Services | Skyland Web - Custom Software Development & IT Solutions</title>
//         <meta 
//           name="description" 
//           content="Skyland Web offers comprehensive IT services including custom software development, web applications, mobile apps, cybersecurity, and digital marketing solutions." 
//         />
//         <meta 
//           name="keywords" 
//           content="software development, web applications, mobile apps, IT services, cybersecurity, digital marketing, SEO, content creation" 
//         />
//         <meta property="og:title" content="Our Services | Skyland Web" />
//         <meta 
//           property="og:description" 
//           content="Professional IT services and custom software solutions tailored to your business needs." 
//         />
//         <meta property="og:type" content="website" />
//         <link rel="canonical" href="https://yourwebsite.com/services" />
//       </Helmet>

//       <div id="services" className="py-16 bg-gradient-to-b from-gray-50 to-white">
//         {/* Header Section */}
//         <div className="text-center mb-16 px-4">
//           <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
//             Our <span className="text-blue-600">Services</span>
//           </h1>
//           <div className="w-20 h-1 bg-blue-600 mx-auto mb-6"></div>
//           <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto">
//             We deliver cutting-edge solutions tailored to your business needs
//           </p>
//         </div>

//         {/* Services Grid */}
//         <div className="container mx-auto px-4">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8">
//             {services.map((service) => (
//               <Link 
//                 to="/contact" 
//                 key={service.id}
//                 className="transform transition-all hover:scale-105 duration-300 px-1 sm:px-0" // Added px-1 for mobile
//               >
//                 <div className={`${service.color} rounded-xl shadow-lg p-6 h-full flex flex-col`}>
//                   <div className="mb-4 flex justify-center">
//                     <div className="p-3 rounded-full bg-white shadow-md">
//                       {service.icon}
//                     </div>
//                   </div>
//                   <h2 className="text-xl font-bold text-gray-800 mb-3 text-center">
//                     {service.title}
//                   </h2>
//                   <p className="text-gray-600 flex-grow">
//                     {service.description}
//                   </p>
//                   <div className="mt-4 text-center">
//                     <span className="inline-block px-4 py-2 text-sm font-medium text-blue-600 bg-white rounded-full shadow hover:bg-blue-50 transition-colors">
//                       Learn More →
//                     </span>
//                   </div>
//                 </div>
//               </Link>
//             ))}
//           </div>
//         </div>

//         {/* Build & Collaborate Section */}
//         <section className="bg-gradient-to-r from-blue-50 to-indigo-50 py-16">
//           <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//             <div className="flex flex-col lg:flex-row gap-8 lg:gap-8 xl:gap-16">
//               {/* We Build Section */}
//               <div className="lg:w-1/2 mb-8 lg:mb-0">
//                 <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 h-full transform transition-all hover:scale-[1.02] duration-300 border border-gray-100">
//                   <div className="flex flex-col h-full">
//                     <div className="flex items-center mb-6">
//                       <div className="bg-blue-100 p-3 sm:p-4 rounded-full mr-4 sm:mr-6">
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="40"
//                           height="40"
//                           viewBox="0 0 24 24"
//                           className="fill-current text-blue-600"
//                         >
//                           <path d="M2 12h2a7.986 7.986 0 0 1 2.337-5.663 7.91 7.91 0 0 1 2.542-1.71 8.12 8.12 0 0 1 6.13-.041A2.488 2.488 0 0 0 17.5 7C18.886 7 20 5.886 20 4.5S18.886 2 17.5 2c-.689 0-1.312.276-1.763.725-2.431-.973-5.223-.958-7.635.059a9.928 9.928 0 0 0-3.18 2.139 9.92 9.92 0 0 0-2.14 3.179A10.005 10.005 0 0 0 2 12zm17.373 3.122c-.401.952-.977 1.808-1.71 2.541s-1.589 1.309-2.542 1.71a8.12 8.12 0 0 1-6.13.041A2.488 2.488 0 0 0 6.5 17C5.114 17 4 18.114 4 19.5S5.114 22 6.5 22c.689 0 1.312-.276 1.763-.725A9.965 9.965 0 0 0 12 22a9.983 9.983 0 0 0 9.217-6.102A9.992 9.992 0 0 0 22 12h-2a7.993 7.993 0 0 1-.627 3.122z"></path>
//                           <path d="M12 7.462c-2.502 0-4.538 2.036-4.538 4.538S9.498 16.538 12 16.538s4.538-2.036 4.538-4.538S14.502 7.462 12 7.462zm0 7.076c-1.399 0-2.538-1.139-2.538-2.538S10.601 9.462 12 9.462s2.538 1.139 2.538 2.538-1.139 2.538-2.538 2.538z"></path>
//                         </svg>
//                       </div>
//                       <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
//                         We <span className="text-blue-600">Build</span>
//                       </h2>
//                     </div>
//                     <p className="text-base sm:text-lg text-gray-600 mb-6 flex-grow">
//                       With over 5 years experience in software analysis and design and a deep understanding of the latest IT trends and solutions, we provide customized recommendations and strategies to help you improve your operations, reduce costs, and increase efficiency.
//                     </p>
//                     <div className="mt-auto">
//                       <div className="grid grid-cols-2 gap-3 sm:gap-4">
//                         <div className="bg-blue-50 p-3 sm:p-4 rounded-lg text-center">
//                           <span className="block text-xl sm:text-2xl font-bold text-blue-600">5+</span>
//                           <span className="text-xs sm:text-sm text-gray-600">Years Experience</span>
//                         </div>
//                         <div className="bg-blue-50 p-3 sm:p-4 rounded-lg text-center">
//                           <span className="block text-xl sm:text-2xl font-bold text-blue-600">100+</span>
//                           <span className="text-xs sm:text-sm text-gray-600">Projects</span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* We Collaborate Section */}
//               <div className="lg:w-1/2">
//                 <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 h-full transform transition-all hover:scale-[1.02] duration-300 border border-gray-100">
//                   <div className="flex flex-col h-full">
//                     <div className="flex items-center mb-6">
//                       <div className="bg-green-100 p-3 sm:p-4 rounded-full mr-4 sm:mr-6">
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="40"
//                           height="40"
//                           viewBox="0 0 24 24"
//                           className="fill-current text-green-600"
//                         >
//                           <path d="m7.375 16.781 1.25-1.562L4.601 12l4.024-3.219-1.25-1.562-5 4a1 1 0 0 0 0 1.562l5 4zm9.25-9.562-1.25 1.562L19.399 12l-4.024 3.219 1.25 1.562 5-4a1 1 0 0 0 0-1.562l-5-4zm-1.649-4.003-4 18-1.953-.434 4-18z"></path>
//                         </svg>
//                       </div>
//                       <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
//                         We <span className="text-green-600">Collaborate</span>
//                       </h2>
//                     </div>
//                     <p className="text-base sm:text-lg text-gray-600 mb-6 flex-grow">
//                       We can collaborate with your existing tech team to scale existing software applications or design customized software applications that suits your everyday need and simplifies various processes.
//                     </p>
//                     <div className="mt-auto">
//                       <ul className="space-y-2 sm:space-y-3">
//                         {[
//                           "Seamless team integration",
//                           "Agile development process",
//                           "Continuous communication",
//                           "Regular progress updates"
//                         ].map((item, index) => (
//                           <li key={index} className="flex items-center">
//                             <svg className="w-4 h-4 sm:w-5 sm:h-5 text-green-500 mr-2 sm:mr-3" fill="currentColor" viewBox="0 0 20 20">
//                               <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
//                             </svg>
//                             <span className="text-sm sm:text-base text-gray-700">{item}</span>
//                           </li>
//                         ))}
//                       </ul>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       </div>
//     </>
//   );
// };

// export default Services;

import React from "react";
import { Link } from "react-router-dom";
import { 
  FaMobileAlt, 
  FaCode,
  FaServer, 
  FaShieldAlt,
  FaDatabase,
  FaCloud
} from "react-icons/fa";
import { 
  MdWeb,
  MdApi
} from "react-icons/md";
import { Helmet } from "react-helmet";

const Services = () => {
  // Focused software services only for Skyland Web
  const services = [
    {
      id: "custom-software-development",
      title: "Custom Software Development",
      icon: <FaCode className="text-4xl text-blue-600" />,
      description: "Tailored solutions built from scratch to meet your unique business requirements.",
      color: "bg-blue-50 hover:bg-blue-100"
    },
    {
      id: "web-application-development",
      title: "Web Application Development",
      icon: <MdWeb className="text-4xl text-indigo-600" />,
      description: "High-performance web apps using React, Node.js and modern frameworks.",
      color: "bg-indigo-50 hover:bg-indigo-100"
    },
    {
      id: "mobile-app-development",
      title: "Mobile App Development",
      icon: <FaMobileAlt className="text-4xl text-purple-600" />,
      description: "Cross-platform mobile apps with Flutter and React Native.",
      color: "bg-purple-50 hover:bg-purple-100"
    },
    {
      id: "cloud-solutions",
      title: "Cloud Solutions",
      icon: <FaCloud className="text-4xl text-cyan-600" />,
      description: "AWS, Azure, and GCP cloud architecture and migration.",
      color: "bg-cyan-50 hover:bg-cyan-100"
    },
    {
      id: "devops-services",
      title: "DevOps Services",
      icon: <FaServer className="text-4xl text-green-600" />,
      description: "CI/CD pipelines and infrastructure automation.",
      color: "bg-green-50 hover:bg-green-100"
    },
    {
      id: "cybersecurity-services",
      title: "Cybersecurity",
      icon: <FaShieldAlt className="text-4xl text-red-600" />,
      description: "Application security testing and protection.",
      color: "bg-red-50 hover:bg-red-100"
    },
    {
      id: "api-development",
      title: "API Development",
      icon: <MdApi className="text-4xl text-amber-600" />,
      description: "RESTful and GraphQL API design and integration.",
      color: "bg-amber-50 hover:bg-amber-100"
    },
    {
      id: "database-solutions",
      title: "Database Solutions",
      icon: <FaDatabase className="text-4xl text-teal-600" />,
      description: "SQL/NoSQL database design and optimization.",
      color: "bg-teal-50 hover:bg-teal-100"
    }
  ];

  return (
    <>
      <Helmet>
        <title>Software Development Services | Skyland Web</title>
        <meta 
          name="description" 
          content="Skyland Web offers professional software development services including custom applications, web development, mobile apps, and cloud solutions." 
        />
      </Helmet>

      {/* Hero Section with Company Name */}
      <div className="relative bg-gradient-to-r from-blue-800 to-indigo-900 py-20 px-4 text-white">
        <div className="max-w-7xl mx-auto text-center">
          <div className="mb-4 text-lg font-medium text-blue-200">
            Skyland Web Services
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Software Solutions <span className="text-blue-300">Tailored For You</span>
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto mb-8">
            Skyland Web builds scalable, secure software that drives business growth
          </p>
          <div className="flex justify-center space-x-4">
            <Link 
              to="/contact" 
              className="bg-white text-blue-800 px-8 py-3 rounded-lg font-semibold hover:bg-blue-100 transition-colors"
            >
              Get Started
            </Link>
          </div>
        </div>
      </div>

      {/* Services Grid */}
      <div id="services" className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Skyland Web <span className="text-blue-600">Services</span>
            </h2>
            <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Specialized software development services to solve your business challenges
            </p>
          </div>

          {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service) => (
              <div 
                key={service.id}
                className={`${service.color} rounded-xl shadow-md hover:shadow-lg transition-shadow p-6 flex flex-col h-full`}
              >
                <div className="mb-5 flex justify-center">
                  <div className="p-3 rounded-full bg-white shadow-sm">
                    {service.icon}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3 text-center">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-5 flex-grow">
                  {service.description}
                </p>
                <Link 
                  to="/contact" 
                  className="text-blue-600 font-medium text-sm hover:text-blue-800 flex items-center justify-center"
                >
                  Learn more
                  <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            ))}
          </div> */}


          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
  {services.map((service) => (
    <div 
      key={service.id}
      id={service.id}
      className={`relative group ${service.color} rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 flex flex-col h-full overflow-hidden`}
    >
      {/* Animated background element */}
      <div className={`absolute inset-0 bg-gradient-to-br from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500`}></div>
      
      {/* Icon with floating animation */}
      <div className="mb-6 flex justify-center">
        <div className="p-4 rounded-2xl bg-white shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:-translate-y-1">
          {React.cloneElement(service.icon, { className: "text-4xl" })}
        </div>
      </div>
      
      {/* Title with subtle underline effect */}
      <h3 className="text-xl font-bold text-gray-800 mb-4 text-center relative pb-2">
        {service.title}
        <span className={`absolute bottom-0 left-1/2 h-0.5 w-8 -translate-x-1/2 ${service.icon.props.className.includes('blue') ? 'bg-blue-600' : 
                         service.icon.props.className.includes('indigo') ? 'bg-indigo-600' :
                         service.icon.props.className.includes('purple') ? 'bg-purple-600' :
                         service.icon.props.className.includes('cyan') ? 'bg-cyan-600' :
                         service.icon.props.className.includes('green') ? 'bg-green-600' :
                         service.icon.props.className.includes('red') ? 'bg-red-600' :
                         service.icon.props.className.includes('amber') ? 'bg-amber-600' : 'bg-teal-600'} 
                         group-hover:w-16 transition-all duration-300`}></span>
      </h3>
      
      {/* Description with better readability */}
      <p className="text-gray-600 mb-6 flex-grow text-center px-2">
        {service.description}
      </p>
      
      {/* Enhanced CTA button */}
      <Link 
        to="/contact" 
        className={`mt-auto inline-flex items-center justify-center px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300
          ${service.icon.props.className.includes('blue') ? 'bg-blue-600 text-white hover:bg-blue-700' : 
            service.icon.props.className.includes('indigo') ? 'bg-indigo-600 text-white hover:bg-indigo-700' :
            service.icon.props.className.includes('purple') ? 'bg-purple-600 text-white hover:bg-purple-700' :
            service.icon.props.className.includes('cyan') ? 'bg-cyan-600 text-white hover:bg-cyan-700' :
            service.icon.props.className.includes('green') ? 'bg-green-600 text-white hover:bg-green-700' :
            service.icon.props.className.includes('red') ? 'bg-red-600 text-white hover:bg-red-700' :
            service.icon.props.className.includes('amber') ? 'bg-amber-600 text-white hover:bg-amber-700' : 'bg-teal-600 text-white hover:bg-teal-700'}
          shadow-md hover:shadow-lg transform group-hover:scale-105`}
      >
        Learn more
        <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
        </svg>
      </Link>
      
      {/* Subtle corner accent */}
      <div className={`absolute top-0 right-0 w-16 h-16 overflow-hidden`}>
        <div className={`absolute top-0 right-0 w-16 h-16 ${service.icon.props.className.includes('blue') ? 'bg-blue-600/10' : 
                       service.icon.props.className.includes('indigo') ? 'bg-indigo-600/10' :
                       service.icon.props.className.includes('purple') ? 'bg-purple-600/10' :
                       service.icon.props.className.includes('cyan') ? 'bg-cyan-600/10' :
                       service.icon.props.className.includes('green') ? 'bg-green-600/10' :
                       service.icon.props.className.includes('red') ? 'bg-red-600/10' :
                       service.icon.props.className.includes('amber') ? 'bg-amber-600/10' : 'bg-teal-600/10'} 
                       transform rotate-45 origin-bottom-left translate-x-8 -translate-y-8`}></div>
      </div>
    </div>
  ))}
</div>
        </div>
      </div>

      {/* Company Expertise Section */}
      <div className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Why Choose <span className="text-blue-600">Skyland Web</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Our approach to software development delivers real results
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                title: "Technical Excellence",
                icon: <FaCode className="text-3xl text-blue-600" />,
                description: "Deep expertise in modern technologies and frameworks"
              },
              {
                title: "Client Focused",
                icon: <MdWeb className="text-3xl text-indigo-600" />,
                description: "Solutions tailored to your specific business needs"
              },
              {
                title: "Proven Results",
                icon: <FaServer className="text-3xl text-green-600" />,
                description: "Track record of successful project deliveries"
              }
            ].map((item, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-8 text-center">
                <div className="flex justify-center mb-4">
                  <div className="p-4 bg-white rounded-full shadow-md">
                    {item.icon}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  {item.title}
                </h3>
                <p className="text-gray-600">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gradient-to-r from-blue-600 to-indigo-700 py-16 px-4 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready to Build With Skyland Web?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Contact us today to discuss your software development needs.
          </p>
          <Link 
            to="/contact" 
            className="inline-block bg-white text-blue-800 px-8 py-3 rounded-lg font-semibold hover:bg-blue-100 transition-colors"
          >
            Get a Free Consultation
          </Link>
        </div>
      </div>
    </>
  );
};

export default Services;